import React from 'react';

const Vue_Setup = () => {
  return (
    <div>
      <h1>Vue_Setup Component</h1>
      <p>This is the Vue_Setup tutorial page.</p>
    </div>
  );
}

export default Vue_Setup;
